import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import { NamedLink } from '../../components';

import { parseRequestTeaser } from '../requestTeaser';
import css from './MarqueeCard.module.css';

/**
 * FairwayBid: Eine Anfrage als Karte.
 *
 * Vorher war jede Kachel eine Textzeile unter einem Bild – lesbar, aber sie
 * verkauft nichts. Ein Händler soll in zwei Sekunden erkennen: Hier will
 * jemand etwas kaufen, so viel darf es kosten, und ich komme mit einem Klick
 * ins Geschäft.
 *
 * Deshalb: Bild oben im festen Seitenverhältnis (sonst tanzen die Karten im
 * Band), die Kategorie als Überschrift, der Budgetrahmen hervorgehoben –
 * er ist das Argument –, die übrigen Angaben daneben, und unten die
 * Handlungsaufforderung.
 *
 * Die ganze Karte ist ein Link zur Registrierung. Die vollständigen Angaben
 * sind Anbietern vorbehalten; das sagt der Abschnittstext darüber, und die
 * Fußzeile der Karte wiederholt es.
 */
const MarqueeCard = props => {
  const { blockId, media, text, title, responsiveImageSizes, options = {} } = props;

  const { headline, facts, budget } = parseRequestTeaser(text?.content);
  // Falls die Console-Zeile mal keine Kategorie hergibt, springt die
  // Überschrift des Blocks ein - und wenn auch die fehlt, ein neutraler Titel.
  const ueberschrift = headline || title?.content || 'Bedarfsanfrage';
  const hatBild = hasDataInFields([media], options);

  return (
    <article className={css.card} id={blockId}>
      <NamedLink name="SignupPage" className={css.link}>
        {hatBild ? (
          <div className={css.media}>
            <Field data={media} sizes={responsiveImageSizes} options={options} />
          </div>
        ) : null}

        <div className={css.body}>
          <span className={css.eyebrow}>Bedarfsanfrage</span>
          <h3 className={css.headline}>{ueberschrift}</h3>

          {budget ? <p className={css.budget}>{budget}</p> : null}

          {facts.length > 0 ? (
            <ul className={css.facts}>
              {facts.map(f => (
                <li key={f} className={css.fact}>
                  {f}
                </li>
              ))}
            </ul>
          ) : null}

          <span className={classNames(css.cta)}>
            Angebot abgeben
            <svg
              className={css.arrow}
              width="14"
              height="14"
              viewBox="0 0 14 14"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M2 7h9M7.5 3.5 11 7l-3.5 3.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </NamedLink>
    </article>
  );
};

export default MarqueeCard;
